export const version = {
  date: '2026-10-27',
  hash: 'ac6d56b',
  longHash: 'ac6d56b7850ed235eadee28e781e3c7c30bef3c8',
};